import React from 'react';
import { SketchBox, type SketchBoxTilt } from './SketchBox';
import { useDesignMode } from '../../contexts/DesignContext';
import { classNames } from '../../utils/classNames';

interface SketchCardProps extends React.HTMLAttributes<HTMLDivElement> {
  tilt?: SketchBoxTilt;
  tiltSeed?: string | number;
}

export const SketchCard: React.FC<SketchCardProps> = ({
  className,
  children,
  tilt = 'auto',
  tiltSeed,
  id,
  ...props
}) => {
  const { isSketchy } = useDesignMode();

  if (isSketchy) {
    return (
      <SketchBox
        tilt={tilt}
        tiltSeed={tiltSeed ?? id}
        className={classNames('p-6', className)}
        id={id}
        {...props}
      >
        {children}
      </SketchBox>
    );
  }

  return (
    <div
      id={id}
      className={classNames(
        'bg-[var(--color-surface)] rounded-2xl shadow-sm border border-[var(--color-border)] p-6',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
